const page = require('../../../../../components/page/page')
const itemDt = require('./item-dt')
const treemap = require('./chart/item-treemap-chart')
const navmenu = require('../../../../../components/navmenu/navmenu')

import itemPage from "./item-page.html";


/****************ELEMENTS*****************/
var HTMLwasSelected = false

//insert the page  on the body
function HTMLselect(detail) {

   HTMLwasSelected = true

   //load the page to the index
   const body = document.body
   body.insertAdjacentHTML("beforeend", itemPage)

   itemDt.start({ "dest": "item", "elem": "dt", "act": "select", "entity": "item" })
   navmenu.start({
      act: 'renderNavMenu',
      container: '#itemdt-navmenu-container',
      items: [
         {
            label: 'Inventory Update',
            icon: 'update',
            dest: 'inventoryUpdate',
            action: 'selectOne',
            extraData: { elem: 'fullcont', id: 'inventoryUpdate-fullcont', entity: 'item' }
         },
         {
            label: 'All Items',
            icon: 'expand',
            dest: 'item',
            action: 'showAllItem',
            extraData: { entity: 'item', elem: 'dt' }
         },
         {
            label: 'Inventory Status',
            icon: 'status_report',
            dest: 'item',
            action: 'printReport',
            extraData: { entity: 'inventory', reportName: 'inventory-items-available', elem: 'fullcont' }
         },
         {
            label: 'Inventory Count',
            icon: 'count_report',
            dest: 'item',
            action: 'printReport',
            extraData: { entity: 'inventory', reportName: 'inventory-count', elem: 'fullcont' }
         },
      ]
   })
   treemap.createTreemapChart("")

}/*init*/

/****************ELEMENTS*****************/

export function start(detail) {

   if (!HTMLwasSelected) { HTMLselect(detail) }

   obj[detail.act].start(detail)
}

const obj = {

   show: { start: (detail) => { page.start(detail) } },
   removeReport: { start: (detail) => { removeReport(detail) } },

}/**/

function removeReport(detail) {
   const reportPage = document.querySelector(`#${detail.pageId}`);

   if (!reportPage) { return }

   reportPage.remove();
}